export function asyncDelay(delay, callback = () => {}) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      callback()
      resolve()
    }, delay)
  })
}

export const BADGE_INFO = [
  {
    key: 'heart',
    icon: require('./images/badge-heart.png'),
    label: 'Moderate intensity for 2% of the day.',
  },
  {
    key: 'foot-silver',
    icon: require('./images/badge-foot-silver.png'),
    label: '5 days in one week meeting step goals.',
  },
  {
    key: 'foot-gold',
    icon: require('./images/badge-foot-gold.png'),
    label: '10 days in two weeks meeting step goals.',
  },
]
